// Kova: clicking the thumbnail of a color's photo selects that color in the variant picker.
if (!customElements.get('kova-media-variants')) {
  customElements.define(
    'kova-media-variants',
    class KovaMediaVariants extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info') || this.closest('section') || document;
        this.gallery = this.root.querySelector('media-gallery');
        if (!this.gallery) return;

        try {
          this.entries = JSON.parse(this.querySelector('script[type="application/json"]').textContent).filter(Boolean);
        } catch {
          this.entries = [];
        }

        // Keep the thumbnails in place: Dawn moves the selected color's photo to the front. The
        // gallery element may not be upgraded yet when this runs.
        customElements.whenDefined('media-gallery').then(() => {
          const setActiveMedia = this.gallery.setActiveMedia.bind(this.gallery);
          this.gallery.setActiveMedia = (mediaId) => setActiveMedia(mediaId, false);
        });

        // After a color change Dawn re-sorts the photos to match the new page, moving the chosen
        // photo to the front; moving it replays its fade-in, which looks like a second refresh.
        // When every photo is already on the page only the active one is switched.
        customElements.whenDefined('product-info').then(() => {
          const productInfo = this.root.matches?.('product-info') ? this.root : null;
          if (!productInfo?.updateMedia) return;
          const updateMedia = productInfo.updateMedia.bind(productInfo);
          productInfo.updateMedia = (html, mediaId) => {
            const current = new Set(
              Array.from(this.gallery.querySelectorAll('ul li[data-media-id]'), (item) => item.dataset.mediaId)
            );
            const incoming = Array.from(html.querySelectorAll('media-gallery ul li[data-media-id]'), (item) => item.dataset.mediaId);
            if (!mediaId || incoming.length !== current.size || !incoming.every((id) => current.has(id))) {
              return updateMedia(html, mediaId);
            }
            this.gallery.setActiveMedia(`${productInfo.dataset.section}-${mediaId}`);
          };
        });

        this.gallery.addEventListener('click', (event) => {
          const item = event.target.closest('.thumbnail-list__item[data-target]');
          if (item) this.selectColorOf(item.dataset.target.split('-').pop());
        });
      }

      // The option that tells this photo apart (usually Color): same value on every variant using
      // the photo, but not the same on every variant of the product.
      optionFor(mediaId) {
        const variants = this.entries.filter((entry) => String(entry.media) === mediaId);
        if (!variants.length) return null;
        const count = variants[0].options.length;
        for (let index = 0; index < count; index++) {
          const value = variants[0].options[index];
          const sameOnPhoto = variants.every((entry) => entry.options[index] === value);
          const variesOnProduct = this.entries.some((entry) => entry.options[index] !== value);
          if (sameOnPhoto && variesOnProduct) return { index, value };
        }
        return null;
      }

      selectColorOf(mediaId) {
        const option = this.optionFor(mediaId);
        const picker = this.root.querySelector('variant-selects');
        if (!option || !picker) return;

        const field = picker.querySelectorAll('.product-form__input')[option.index];
        if (!field) return;

        const radio = Array.from(field.querySelectorAll('input[type="radio"]')).find((input) => input.value === option.value);
        if (radio) {
          if (!radio.checked) radio.click();
          return;
        }

        const select = field.querySelector('select');
        const match = select && Array.from(select.options).find((item) => item.textContent.trim() === option.value);
        if (match && !match.selected) {
          select.value = match.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  );
}
